export default __webpack_public_path__ + "static/media/interactivity.a291a9cb.png";